import { Component, OnInit, ViewChild } from '@angular/core';
import { Input } from '@angular/core';
import { CustomStorage } from '../providers/Custom-storage.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { DialogComponent } from '../dialog/dialog.component';
import { LanguageService } from '../providers/lang.service';
 import { ViewStateService } from '../providers/viewstate';
import { CartitemsService } from '../providers/cartitems.service';
import { environment } from '../../environments/environment';
import { NgForm } from '@angular/forms';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Toast, ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { BrowserModule } from '@angular/platform-browser';
import { Directive, ElementRef } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { SharedServiceService } from '../shared/shared-service.service';
import { RestApiServices } from '../providers/rest.service';


@Component({
  selector: 'app-product-item',
  templateUrl: './product-item.component.html',
  styleUrls: ['./product-item.component.css']
})
export class ProductItemComponent implements OnInit {
  @ViewChild('f') signupForm: NgForm;
  viewState :any;
  viewdesState :any;
  selectedInstock: number;
  companyControl = new FormControl('', [Validators.required]);
  private imageUrl = environment.imageUrl;
  selectedSize: any = 0; selectedquantity: any = 0; quantityValue: number; selectedColor: any = 1;
  showDialog: boolean = false;blank_qty: string = "";
  spinnervalue: boolean = false;
  colorNotApplicable: boolean = false;
  hideSizeSpinner: boolean = false;
  hideColorSpinner: boolean = false;  
  showErrorMsg =   false; 
  isPopState = false; 
  unique_array = [];getselecteddata:any ={};
  @Input('product') product: any = {};
  @Input() item_number;  @Input() stock; @Input() yes_txt; @Input() no_txt;@Input() incart;
  @Input() txt_color; @Input() txt_size; @Input() txt_stock;@Input() added_message;
  @Input() addtocart; @Input() color_txt; @Input() size_txt; @Input() quantity_text; @Input() cart_msg1; @Input() cart_msg2; @Input() cart_msg3;
  @Input() Lbl_check;@Input() item_uom;@Input() item_qty; @Input() pack_size; @Input() pallet_quantity;
  msg_added : string = "";description: string = "";txt_validqty: string = "";lbl_pack: string = "Pack Size";lbl_pallet_quantity: string = "Pallet Quantity";
  private toasterService: ToasterService;
  public config: ToasterConfig = new ToasterConfig({
    positionClass: 'toast-top-center'

  });
  submitted = false;
  errorquantitymsg: boolean = false;  
  showDialogaddtocart = false;
  cartlistItems:any=[];
  cartItems:any=[];
  colorSelected: boolean = true;
  sizeSelected: boolean = false;
  labelstatus: boolean = false;
  constructor(private localStorage: CustomStorage, private restApi: RestApiServices,public router: Router, public el: ElementRef,
    private langService: LanguageService, private viewstateservice: ViewStateService,private activatedRoute: ActivatedRoute, private locStrat: LocationStrategy, private sharedService: SharedServiceService, private localCart: CartitemsService, toasterService: ToasterService, private route: ActivatedRoute) {
    this.toasterService = toasterService;
    this.el.nativeElement.onkeypress = (event) => {
      if (event.which >= 48 && event.which <= 57) {
        // to allow numbers  
        return true;
        //  } else if (event.which >= 96 && event.which <= 105) {  
        //      // to allow numpad number  
        //      return true;  
      } else if ([8, 0, 127, 46].indexOf(event.which) > -1) {
        // to allow backspace, enter, escape, arrows  
        return true;
      }
      else {
        event.preventDefault();
        // to stop others  
        return false;
      }

    };

  }

  ngOnInit() {
    
    this.langService.getJson().subscribe(data => {
      this.setLabels();
      for (let indx = 0; indx < this.product.more_product_data.length; indx++) {
        if (this.unique_array.indexOf(this.product.more_product_data[indx].color) == -1) {
          this.unique_array.push(this.product.more_product_data[indx].color);
         // console.log("color is:"+ this.unique_array);
        }
        
      }

      //console.log(JSON.stringify(this.product));
      this.checkcartitem(this.product);
      this.localCart.cartList.subscribe(res => {
        this.cartlistItems = res;
        this.checkcartitem(this.product);
            });
      this.hidespinner();
      this.hidesizespinner();
      this.validateSubmit();
      
      // console.log(this);
    
    // this.localStorage.getItem('product').subscribe(data => {
    //   if (data != null && data != undefined) {
    //     for(let indx = 0; indx < data.more_product_data.length; indx++){
    //       if(this.unique_array.indexOf(data.more_product_data[indx].color) == -1){
    //           this.unique_array.push(data.more_product_data[indx].color);
            
    //       }
    //   }
    //     this.product = data;
    //     console.log("shop dta is"+JSON.stringify(this.popToast))
    //     this.hidespinner();
    //   }
  
    // });
  });
  }
  ngOnDestroy(){

  }
  currentProduct: any;
  addItemInCart(product) {
    this.colorSelected = this.selectedColor != 0;
    this.sizeSelected = this.selectedSize != 0;
    this.currentProduct = product;

    this.validateSubmit()
    if(this.quantityValue <= 0 || this.quantityValue == undefined){
      this.errorquantitymsg = true
     return true;
    }
    if(this.quantityValue > this.getRealItemStock()){
      console.log(this.product);
      this.showDialog = !this.showDialog;
      return true;
         }
   if(this.hidespinner() || this.hidesizespinner()){
     if(this.showErrorMsg){
       return false
     }
    this.proceed();
    return true

   } 
   else if(!this.colorSelected || !this.sizeSelected){
    return false;
  }
   
    // if(this.quantityValue > this.getSelectedItemStock()){
    //   this.showDialog = !this.showDialog;
    // }else{
      this.proceed();
   // }
   
  }
  proceed() {
    let product = this.currentProduct;
    this.showDialogaddtocart = !this.showDialogaddtocart
    let selectedCartItem = Object.assign({}, product);
    this.submitted = true;
    let colorValue = this.signupForm.value.userData.color;
    let sizeValue = this.signupForm.value.userData.size;
    let quantityValue = this.signupForm.value.userData.quantity;
    let unique_id_t =  product.item_number
    if(colorValue){
      selectedCartItem.item_color = colorValue.color;
      unique_id_t += colorValue.color
    }
    if(sizeValue){
      selectedCartItem.item_size = sizeValue.size;
      unique_id_t += sizeValue.size
    }
    selectedCartItem.unit_price = product.price;
    selectedCartItem.unique_id  = unique_id_t;
    selectedCartItem.quantity = Number.parseFloat(quantityValue.quantity);
    this.localCart.addItemtoCart(selectedCartItem);
    this.popToast();
    this.showDialog = false;
    //this.router.navigate(['/dashboard/shop/topsales']);
  }
  itemSelected(product) {
    this.localStorage.setItem('productSelected', product).subscribe(res => {
      this.router.navigate(['/productdetails']);
    });
  }
  unitprice = [];
  instock = [];
  sizeData = [];
  colorChanged(selectedColor) {
    this.sizeData = [];
    this.instock = [];
    this.colorSelected = false;
    for (let item of this.product.more_product_data) {
      if (selectedColor == item.color) {
        this.sizeData.push(item.size);
        this.instock.push(item.in_stock);
        this.unitprice.push(item.unit_price);
        this.colorSelected =   true
        this.sizeSelected = true
      }
    }
    if (this.sizeData.length > 0) {
      this.selectedSize = this.sizeData[0];
    }
    this.validateSubmit()

  }

  sizeChanged(selectedSize) {
    this.sizeData = [];
    this.instock = [];
    this.sizeSelected = false;
     
    for (let item of this.product.more_product_data) {
      let descriptionString = item.size + " " + item.color;
      if (descriptionString == selectedSize) {
        // this.sizeData.push(item.size);
        this.instock.push(item.in_stock);
        this.unitprice.push(item.unit_price);
        this.selectedSize = item.size;
        this.selectedColor = item.color;
      }
    }
    if(this.sizeData.length > 0){
      this.selectedSize = this.sizeData[0];
    }
    this.validateSubmit()
  }

  popToast() {
    var toast: Toast = {
      type: 'info',
      title: this.description,
      body: this.msg_added
    };

    this.toasterService.pop(toast);
  }

  validQuantity() {
    //if(this.selectedColor === undefined || this.selectedSize === undefined || this.quantityValue === undefined){
    if (this.quantityValue == undefined && this.quantityValue <= 0) {
      //if color and size is not selected then we are not validaing stock
      return true;
    }
    this.validateSubmit();
    let instock = this.getSelectedItemStock();
    if (instock > 0 && this.quantityValue > instock) {
      return false;
    }
    // this.someProperty = !this.someProperty
    return true;

  }

  // getSelectedItemStock() {
  //   if (this.product.more_product_data.length <= 0) {
  //     return this.product.qty_on_hand;
  //   }
  //   for (let item of this.product.more_product_data) {
  //     if(this.selectedColor ==  "Not Applicable"){
  //       return this.product.qty_on_hand
  //     }
  //     if (this.selectedColor == item.color && this.selectedSize == item.size) {
  //       this.selectedInstock = item["in_stock"];
  //       return item["in_stock"];
  //     }
    
  //   }
  // }
  getSelectedItemStock(){
    // console.log(this.productDetails.more_product_data.length)   
    if(this.product.more_product_data.length <= 0){
      return Math.floor(this.product.qty_on_hand - this.product.commit_qty);
    }
    for (let item of this.product.more_product_data) {
      if (this.selectedColor == item.color && this.selectedSize == item.size) {
        
        this.selectedInstock = item["in_stock"];
        return item["in_stock"];
      }
      if (this.selectedSize == item.size) {
        this.selectedInstock = item["in_stock"];
        return item["in_stock"];
      }
    }
  }

  getRealItemStock(){
    return Math.floor(this.product.qty_on_hand) - Math.floor(this.product.commit_qty);
  }

  // Function created for the purpose of validating Overship
  calculateOvershipQuantity(){
    if (this.getRealItemStock() <= 0){
      return this.quantityValue;
    } else {
      let overship =  this.quantityValue - this.getRealItemStock();
      return overship;
    }
  }

  canSubmit() {
    //console.log(this.product);
    if (this.product.more_product_data.length <= 0) {
      return this.quantityValue > 0 && this.getRealItemStock() > 0;
    }
    return this.quantityValue > 0;

    // return this.selectedColor != 0 && this.selectedSize != 0 && this.quantityValue > 0;
  }
  hidespinner() {
    for (let indx = 0; indx < this.product.more_product_data.length; indx++) {
      if (this.product.more_product_data[indx].color == "Not Applicable") {
        this.hideColorSpinner = true;
        this.selectedColor =  "Not Applicable"
        return true
      }
    }
    return false
  }
  hidesizespinner() {
    for (let indx = 0; indx < this.product.more_product_data.length; indx++) {
      if (this.product.more_product_data[indx].size == "Not Applicable") {
        this.hideSizeSpinner = true;
        this.selectedSize =  "Not Applicable"
        return true
      }
    }
    return false
  }

  validateSubmit(){
    let valid =  true
    valid = valid && (this.hideColorSpinner || this.colorSelected)
    valid = valid && (this.hideSizeSpinner || this.sizeSelected)
    // valid =  this.getSelectedItemStock() >= this.quantityValue 
    // this.showErrorMsg = !valid || this.quantityValue <= 0 || this.getRealItemStock() <= 0;
    this.showErrorMsg = !valid && this.quantityValue <= 0 && this.quantityValue == undefined;
    
  }

  getErrorMsg(){
    if (this.getRealItemStock() <= 0){
      return "This Item has no stock at the moment. Check again later";
    }

    if(!this.hideColorSpinner && !this.hideSizeSpinner){
      if(!this.colorSelected && !this.sizeSelected){
        return "Please Select color and Size";
      }
      if(!this.colorSelected){
        return "Please Select Color";
      }
      if(!this.sizeSelected){
        return "Please Select Size";
      }
    }

    if(!this.hideColorSpinner ){
      
      if(!this.colorSelected){
        return "Please Select Color";
      }
     
    }

    if(!this.hideSizeSpinner){
     
      if(!this.sizeSelected){
        return "Please Select Size";
      }
    }

    if (this.quantityValue > this.getRealItemStock() ){
      return "Item Quantity is higher than available stock";
    }

    if (this.quantityValue <= 0){
      return "Please enter a quantity larger than 0";
    }
  }
checkcartitem(product){
  this.cartItems= this.localCart.getCartItems();
  if(this.cartItems.length > 0){
  for (let cart of this.cartItems) {
      if(cart.item_number == this.product.item_number){
        this.labelstatus=true;
        return true;
      }
    }
      
  }
  return this.labelstatus=false;
}

isNegativeInvOrderNotAllowed() {
  return (this.sharedService.getDoNotAllowNegativeInvOrder());
}

setLabels() {
  this.langService.getLangLabelValue("LblItemAddedSuccesfuly").then(result => {
    this.msg_added = result; 
  });
  this.langService.getLangLabelValue("LblDescription").then(result => {
    this.description = result; 
  });
  this.langService.getLangLabelValue("LblQuantityCantBeBlank").then(result => {
    this.blank_qty = result;  
  });
  this.langService.getLangLabelValue("200_enter_valid_quantity").then(result => {
    this.txt_validqty = result;  
  });
}

}



// WEBPACK FOOTER //
// ./src/app/product-item/product-item.component.ts